import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

/* babel-plugin-inline-import '../../assets/images/close.svg' */
const CloseSVG = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNC4yNTIgMTQuMjUyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntjbGlwLXBhdGg6dXJsKCNhKTt9LmN7ZmlsbDojMmUzMDMwO308L3N0eWxlPjxjbGlwUGF0aCBpZD0iYSI+PHJlY3QgY2xhc3M9ImEiIHdpZHRoPSIxNC4yNTIiIGhlaWdodD0iMTQuMjUyIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xhc3M9ImIiPjxyZWN0IGNsYXNzPSJjIiB3aWR0aD0iMTcuOTk1IiBoZWlnaHQ9IjIuMTU5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUyNykgcm90YXRlKDQ1KSIvPjxyZWN0IGNsYXNzPSJjIiB3aWR0aD0iMTcuOTk1IiBoZWlnaHQ9IjIuMTU5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC4yNTIgMS41MjcpIHJvdGF0ZSgxMzUpIi8+PC9nPjwvc3ZnPg==";

/* babel-plugin-inline-import '../../assets/images/hamburger.svg' */
const HamburgerSVG = "data:image/svg+xml;base64,PHN2Zwogd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IgogICAgICAgICAgICBjbGFzc05hbWU9ImZpbGwtY3VycmVudCBoLTUgdy01IgogICAgICAgICAgICB2aWV3Qm94PSIwIDAgMjAgMjAiCiAgICAgICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICAgICAgID4KICAgICAgICAgICAgPHRpdGxlPk1lbnU8L3RpdGxlPgogICAgICAgICAgICA8cGF0aCBkPSJNMCAzaDIwdjJIMFYzem0wIDZoMjB2MkgwVjl6bTAgNmgyMHYySDB2LTJ6Ij48L3BhdGg+CiAgICAgICAgICA8L3N2Zz4=";
import { Logo } from "../logo";
import { NavItem } from "./item";
export { NavItem };
export const Nav = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any[]} props.items
 * @param {any} [props.className]
 * @param {any} [props.itemsClassName]
 * @param {any} [props.linkComponent]
 * @param {string} [props.homeLink]
 * @param {any} [props.children]
 * @param {any} [props.altChildren]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Nav({
  items = [],
  className,
  itemsClassName,
  linkComponent,
  homeLink,
  children,
  altChildren
}, ref) {
  const [selected, setSelected] = useState(null);
  const [hidden, setHidden] = useState(true);

  const toggleSelection = value => {
    setSelected(value === selected ? null : value);
  };

  const Link = linkComponent || "a";
  const navClasses = classnames(["flex items-center justify-between flex-wrap fixed w-full z-20 top-0 font-sans bg-white shadow en-nav", "max-h-screen overflow-x-hidden overflow-y-auto xl:overflow-visible"], className);
  const middleClasses = classnames(["w-full xl:flex xl:items-center xl:w-auto xl:block xl:pt-0 font-bold xl:font-normal middle-container z-20"]);
  const rightClasses = classnames(["w-full xl:flex xl:items-center xl:w-auto xl:block xl:pt-0 font-gotham-book right-container z-10"], {
    hidden
  });

  const toggleHidden = () => {
    setHidden(!hidden);
  };

  useEffect(() => {
    function onCheckboxChange() {
      document.getElementsByName("nav-item-check").forEach(checkbox => {
        if (checkbox !== this) {
          // @ts-ignore
          checkbox.checked = false;
        }
      });
    }

    document.querySelectorAll("[name='nav-item-check']").forEach(elem => {
      elem.addEventListener("change", onCheckboxChange);
    });
    return () => {
      document.querySelectorAll("[name='nav-item-check']").forEach(elem => {
        elem.removeEventListener("change", onCheckboxChange);
      });
    };
  }, []);
  useEffect(() => {
    if (typeof window === "undefined") return;

    function clickHandler(e) {
      if (!e.target.closest("nav.en-nav")) {
        document.querySelectorAll("[name='nav-item-check']").forEach(elem => {
          // @ts-ignore
          elem.checked = false;
        });
      }
    }

    window.addEventListener("click", clickHandler);
    return () => window.removeEventListener("click", clickHandler);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: navClasses,
    ref: ref
  }, /*#__PURE__*/React.createElement("input", {
    id: "nav-hamburger-check",
    type: "checkbox",
    className: "hidden",
    onChange: toggleHidden
  }), /*#__PURE__*/React.createElement("div", {
    id: "nav-header",
    className: "block w-full xl:w-auto xl:flex items-center flex-shrink-0 text-gray-800 m-4"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "no-underline hover:no-underline logo",
    href: homeLink || "/"
  }, /*#__PURE__*/React.createElement(Logo, {
    width: "150px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block float-right xl:hidden mr-6"
  }, altChildren, children || altChildren ? /*#__PURE__*/React.createElement("label", {
    id: "nav-toggle",
    className: "float-right flex items-center px-3 py-2 focus:outline-none cursor-pointer",
    role: "button",
    htmlFor: "nav-hamburger-check"
  }, /*#__PURE__*/React.createElement("img", {
    id: "nav-hamburger-close",
    className: "fill-current inline align-top",
    src: CloseSVG,
    alt: hidden ? "Open Menu" : "Close Menu"
  }), /*#__PURE__*/React.createElement("img", {
    id: "nav-hamburger-open",
    className: "fill-current inline align-top",
    src: HamburgerSVG,
    alt: hidden ? "Open Menu" : "Close Menu"
  })) : null)), /*#__PURE__*/React.createElement("div", {
    id: "nav-content",
    className: middleClasses
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-reset xl:flex items-center"
  }, items.map(item => /*#__PURE__*/React.createElement(NavItem, {
    item: item,
    key: item.text,
    className: "text-gray-800 py-4 xl:py-1  border xl:border-none",
    containerClassName: itemsClassName,
    isOpen: selected === item.text,
    onClick: () => toggleSelection(item.text),
    linkComponent: item.linkComponent || linkComponent
  })))), /*#__PURE__*/React.createElement("div", {
    className: rightClasses
  }, children)), hidden ? null : /*#__PURE__*/React.createElement("div", {
    className: "fixed left-0 top-0 w-screen h-screen bg-en-gray-800 bg-opacity-75 z-10 xl:hidden"
  }));
});
Nav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string
    })),
    text: PropTypes.string.isRequired,
    linkComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType])
  })),
  className: PropTypes.string,
  itemsClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linkComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType]),
  children: PropTypes.any,
  altChildren: PropTypes.any,
  homeLink: PropTypes.string
};